import { Log, MileageLossCode } from '@/types/logs'
import { MileageLoss } from '../types'

export const calculateMileageLoss = (logs: Log[] = []): MileageLoss => {
    const result = {
        [MileageLossCode.T]: 0,
        [MileageLossCode.S]: 0,
        [MileageLossCode.M]: 0,
        [MileageLossCode.NSB]: 0,
        [MileageLossCode.OD]: 0,
        [MileageLossCode.OND]: 0,
        [MileageLossCode.E]: 0,
    }

    if (!logs.length) {
        return result
    }

    logs.forEach(({ code, mileage }) => {
        if (code in result && mileage) {
            result[code as MileageLossCode] += mileage
        }
    })

    return result
}
